let configPath = "config.json";
let proxyUrl =
  "https://pokupka-test2.podeli.ru/proxy/?openInBrowser=true&redirectUrl=";
const certProxyUrl =
  "https://pokupka-cert.podeli.ru/proxy/?openInBrowser=true&redirectUrl=";
const PARTNERS = {
  LETU: "letu",
  LACOSTE: "lacoste",
  BEFREE: "befree",
  SUPERSTEP: "superstep",
};
const externalPartnerIds = {
  [PARTNERS.LETU]: "43f9d873-1ecb-453f-b841-c782c1a30972",
  [PARTNERS.LACOSTE]: "321e22fe-af86-4f2a-9e07-c149bf168711",
  [PARTNERS.BEFREE]: "1160a962-de60-4eed-9607-6a88c5ba5684",
  [PARTNERS.SUPERSTEP]: "6f731849-b00f-4b77-bf64-5c846182f1b3",
};
let utm_source = "alfamobile";
if (window.location.hostname === "podeli.ru") {
  configPath = "https://catalog-cdn.podeli.ru/front/config.json";
}

let isCatalog = false;

const CATALOG_TYPES = {
  CATALOG: "catalog",
  APP: "app",
  AM: "am",
  AO: "ao",
};
let catalogType = CATALOG_TYPES.APP;

if (
  window.location.pathname === "/catalog" ||
  window.location.pathname === "/test_catalog"
) {
  isCatalog = true;
  catalogType = CATALOG_TYPES.CATALOG;
} else if (
  window.location.pathname === "/app_shop_am" ||
  window.location.pathname === "/test_app_shop_am"
) {
  catalogType = CATALOG_TYPES.AM;
  utm_source = "alfamobile";
} else if (
  window.location.pathname === "/app_shop_ao" ||
  window.location.pathname === "/test_app_shop_ao"
) {
  catalogType = CATALOG_TYPES.AO;
}
const prepareUtmLink = (link, hide_utm) => {
  let symbol = link.indexOf("?") === -1 ? "?" : "&";
  let utm =
    symbol +
    `utm_source=${utm_source}&utm_medium=banner&utm_campaign=` +
    (isCatalog ? "podeli_web" : "podeli_app");
  let externalPartnerId = "";
  if (link && link.indexOf(PARTNERS.LETU) > -1) {
    externalPartnerId =
      "&externalPartnerId=" + externalPartnerIds[PARTNERS.LETU];
  } else if (link && link.indexOf(PARTNERS.LACOSTE) > -1) {
    externalPartnerId =
      "&externalPartnerId=" + externalPartnerIds[PARTNERS.LACOSTE];
  } else if (link && link.indexOf(PARTNERS.BEFREE) > -1) {
    externalPartnerId =
      "&externalPartnerId=" + externalPartnerIds[PARTNERS.BEFREE];
    return (
      certProxyUrl + "%" + link + (!hide_utm ? utm : "") + externalPartnerId + "%"
    );
  } else if (link && link.indexOf(PARTNERS.SUPERSTEP) > -1) {
    externalPartnerId =
      "&externalPartnerId=" + externalPartnerIds[PARTNERS.SUPERSTEP];
    return (
      certProxyUrl + "%" + link + (!hide_utm ? utm : "") + externalPartnerId + "%"
    );
  }
  return (
    proxyUrl + "%" + link + (!hide_utm ? utm : "") + externalPartnerId + "%"
  );
};

export { isCatalog, catalogType, configPath, CATALOG_TYPES, prepareUtmLink };

export const getUrlImage = (props) => {
  return (props.data && props.data.attributes.url) || "";
};

export const targetMetrick = (target) => {
  if (window.ym) {
    window.ym(93798687, "reachGoal", target);
  }
};

export const getLinkTheme = (url, params) => {
  let theme = "";
  if (params && params !== "podeli") {
    theme = "?theme=" + params;
  }

  return url + theme;
};
export const shuffle = (array) => {
  return array.sort(() => Math.random() - 0.5);
};

export const shuffleArrayExceptFirstThree = (array) => {
  // Проверка, что массив имеет более трех элементов
  if (array.length <= 3) {
    return array; // Нечего перемешивать
  }

  // Разделение массива на три части: первые три элемента и оставшаяся часть
  const firstThree = array.slice(0, 5);
  const rest = array.slice(5);

  // Функция для перемешивания массива с использованием алгоритма Фишера-Йетса
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
  }

  // Перемешиваем оставшуюся часть массива
  const shuffledRest = shuffle(rest);

  // Соединяем первые три элемента и перемешанную оставшуюся часть
  return firstThree.concat(shuffledRest);
};
